'use strict';

var _ = require('lodash');
var FaresOptimizerAlignFaresService = function FaresOptimizerAlignFaresService(FaresOptimizerConstants, restangular, faresOptimizerDataTransformerService, $q, app) {
  var alignFaresService = restangular.one('external').one('faresoptimizer').one('recommendationladder').one('alignfares');
  var THRESHOLD_PRECISION = 2;
  function getRegularFbcGroupedRows(groupedRows) {
    return _.filter(groupedRows, function (groupedRow) {
      return !groupedRow.isLinkedFbc && !groupedRow.isDualRbdFare;
    });
  }
  function resetCompetitorAlignmentFields(effFareLadder) {
    effFareLadder.competitorCarrier = undefined;
    effFareLadder.competitorFbc = undefined;
    effFareLadder.competitorOrigin = undefined;
    effFareLadder.competitorDestination = undefined;
    effFareLadder.competitorTariffCode = undefined;
    effFareLadder.competitorRoutingNumber = undefined;
    effFareLadder.competitorFootnote = undefined;
    effFareLadder.competitorFareSource = undefined;
  }
  function alignEffectiveFares(chartData, effFareLadder, selectedRecomLadderFromRawData, effFareGroupedRows) {
    var regularFbcEffFareGroupedRows = getRegularFbcGroupedRows(effFareGroupedRows);
    var alignPayload = {
      recordKey: selectedRecomLadderFromRawData.fareRecommendationRecordKey
    };
    resetCompetitorAlignmentFields(effFareLadder);
    if (chartData.title.indexOf(FaresOptimizerConstants.RECOMMENDATION_CHART_TITLE) > -1) {
      alignPayload.alignedWith = FaresOptimizerConstants.RECOMMENDATION_CHART_TITLE;
    } else if (chartData.title.indexOf(FaresOptimizerConstants.CURRENT) > -1) {
      alignPayload.alignedWith = FaresOptimizerConstants.CURRENT;
    } else {
      if (_.isNil(selectedRecomLadderFromRawData.currentFareTotal) && _.isNil(selectedRecomLadderFromRawData.recommendedFareTotal)) {
        var noRecomMap = selectedRecomLadderFromRawData.ladderRemarks.noRecommendationReasons;
        var noRecomReason = Object.keys(noRecomMap);
        return $q.reject(noRecomReason[0]);
      }
      alignPayload.alignedWith = FaresOptimizerConstants.COMPETITOR;
      alignPayload.competitorCarrier = chartData.data.carrier;
      alignPayload.competitorFbc = _.isNil(chartData.data.competitorFareLadder[0]) ? chartData.data.fbc : chartData.data.competitorFareLadder[0].fareBasisCode;
      alignPayload.competitorOrigin = chartData.data.origin;
      alignPayload.competitorDestination = chartData.data.destination;
      alignPayload.competitorTariffCode = chartData.data.tariffCode;
      alignPayload.competitorRoutingNumber = chartData.data.routingNumber;
      alignPayload.competitorFootnote = chartData.data.footnote;
      alignPayload.competitorFareSource = chartData.data.fareSource;
    }
    return alignFaresService.customPOST(alignPayload).then(_.partialRight(transformRecommendationLadder, effFareLadder, regularFbcEffFareGroupedRows, chartData));
  }
  function transformRecommendationLadder(selectedLadder, effFareLadder, regularFbcEffFareGroupedRows, chartData) {
    var transformedData = faresOptimizerDataTransformerService.transformRecommendationLadder({
      foRecommendationLadderList: [selectedLadder]
    });
    var transformedLadder = _.isArray(transformedData) ? _.first(transformedData) : transformedData;
    var groupedRows = _.chain(transformedLadder).get('groupedRows', []).map(function (groupedRow) {
      return _.pick(groupedRow, 'market', 'rbd', 'fbc', 'effectiveTotalFare', 'recommendedFareTotal', 'currentFareTotal', 'minFareThreshold', 'maxFareThreshold', 'benchmarkFareComponent', 'yq', 'yr', 'q', 'airportTax', 'variable', 'variableTaxPercentage', 'sponsorMarketFbc', 'dualRbdSponsorFbc', 'isLinkedFbc', 'isDualRbdFare', 'isEntryLevel', 'userAdjustedDates', 'actionCode');
    }).value();
    effFareLadder = groupedRows;
    effFareLadder.alignedWith = transformedLadder.alignedWith;
    effFareLadder.userAdjustedDates = transformedLadder.userAdjustedDates || [];
    if (effFareLadder.alignedWith === FaresOptimizerConstants.COMPETITOR) {
      effFareLadder.competitorCarrier = chartData.data.carrier;
      effFareLadder.competitorFbc = _.isNil(chartData.data.competitorFareLadder[0]) ? chartData.data.fbc : chartData.data.competitorFareLadder[0].fareBasisCode;
      effFareLadder.competitorOrigin = chartData.data.origin;
      effFareLadder.competitorDestination = chartData.data.destination;
      effFareLadder.competitorTariffCode = chartData.data.tariffCode;
      effFareLadder.competitorRoutingNumber = chartData.data.routingNumber;
      effFareLadder.competitorFootnote = chartData.data.footnote;
      effFareLadder.competitorFareSource = chartData.data.fareSource;
    }
    return effFareLadder;
  }
  function updateEffectiveFaresInGroupedRows(effFareLadder, groupedRows) {
    _.forEach(effFareLadder, function (effFare, index) {
      if (effFare.fbc === groupedRows[index].fbc) {
        groupedRows[index].effectiveTotalFare = effFare.effectiveTotalFare;
      }
    });
  }
  function updateRecommendedFaresInGroupedRows(alignedFareLadder, groupedRows) {
    _.forEach(alignedFareLadder, function (newFbc, index) {
      if (newFbc.fbc === groupedRows[index].fbc) {
        groupedRows[index].recommendedFareTotal = newFbc.recommendedFareTotal;
        groupedRows[index].benchmarkFareComponent = newFbc.benchmarkFareComponent;
      }
    });
  }
  function updateCurrentFaresInGroupedRows(alignedFareLadder, groupedRows) {
    _.forEach(alignedFareLadder, function (newFbc, index) {
      if (newFbc.fbc === groupedRows[index].fbc) {
        groupedRows[index].currentFareTotal = newFbc.currentFareTotal;
      }
    });
  }
  function getHostLadderData(ladder) {
    return _.chain(ladder.groupedRows).sortBy('effectiveTotalFare').reduce(function (hostLadder, groupedRow) {
      hostLadder.push({
        market: groupedRow.market,
        rbd: groupedRow.rbd,
        fbc: groupedRow.fbc,
        effectiveTotalFare: groupedRow.effectiveTotalFare,
        recommendedTotalFare: groupedRow.recommendedFareTotal,
        minFareThreshold: groupedRow.minFareThreshold,
        maxFareThreshold: groupedRow.maxFareThreshold,
        sponsorMarketFbc: groupedRow.sponsorMarketFbc,
        dualRbdSponsorFbc: groupedRow.dualRbdSponsorFbc,
        percentageLinkageFactor: groupedRow.percentageLinkageFactor,
        absoluteLinkageFactor: groupedRow.absoluteLinkageFactor,
        benchmarkFareComponent: groupedRow.benchmarkFareComponent,
        yq: groupedRow.yq,
        yr: groupedRow.yr,
        q: groupedRow.q,
        airportTax: groupedRow.airportTax,
        variable: groupedRow.variable,
        variableTaxPercentage: groupedRow.variableTaxPercentage
      });
      return hostLadder;
    }, []).value();
  }
  function setAdjustEffectiveFareData(entryLevelEffectiveFare, selectedFareLadder) {
    entryLevelEffectiveFare.hostLadder = getHostLadderData(selectedFareLadder);
    entryLevelEffectiveFare.status = selectedFareLadder.status;
  }
  function areRecommendedFaresValid(currentRow) {
    return _.findIndex(currentRow.data.groupedRows, function (recommendation) {
      return !_.isNil(recommendation.recommendedFareTotal);
    }) >= 0;
  }
  function areCurrentFaresValid(currentRow) {
    return _.findIndex(currentRow.data.groupedRows, function (recommendation) {
      return !_.isNil(recommendation.currentFareTotal);
    }) >= 0;
  }
  function checkAlignButtonStatus(currentRow) {
    return currentRow.title.indexOf(FaresOptimizerConstants.RECOMMENDATION_CHART_TITLE) > -1 && !areRecommendedFaresValid(currentRow) || currentRow.title.indexOf(FaresOptimizerConstants.CURRENT) > -1 && !areCurrentFaresValid(currentRow);
  }
  function getTotalFareGivenThreshold(fareThreshold, benchmarkFareComponent, groupedRow) {
    var totalFare = fareThreshold;
    for (var i = 1; i < benchmarkFareComponent.length; i++) {
      var benchmarkValue = benchmarkFareComponent.charAt(i);
      if (benchmarkValue === '1') {
        switch (i) {
          case 1:
            totalFare += !_.isNil(groupedRow.yq) ? groupedRow.yq : 0;
            break;
          case 2:
            totalFare += !_.isNil(groupedRow.yr) ? groupedRow.yr : 0;
            break;
          case 3:
            totalFare += !_.isNil(groupedRow.q) ? groupedRow.q : 0;
            break;
          case 4:
            totalFare += !_.isNil(groupedRow.airportTax) ? groupedRow.airportTax : 0;
            break;
          case 5:
            totalFare += getRecommendedVariable(groupedRow, fareThreshold);
            break;
          case 6:
            totalFare += !_.isNil(groupedRow.qMisc) ? groupedRow.qMisc : 0;
            break;
        }
      }
    }
    return Math.round(totalFare);
  }
  function getTotalFareThreshold(fareThreshold, groupedRow, benchmarkFareComponent) {
    return _.toNumber(getTotalFareGivenThreshold(fareThreshold, benchmarkFareComponent, groupedRow).toFixed(THRESHOLD_PRECISION));
  }
  function getRecommendedVariable(groupedRow, fareThreshold) {
    var baseFare = !_.isNil(fareThreshold) ? fareThreshold : 0;
    var yq = !_.isNil(groupedRow.yq) ? groupedRow.yq : 0;
    var yr = !_.isNil(groupedRow.yr) ? groupedRow.yr : 0;
    var q = !_.isNil(groupedRow.q) ? groupedRow.q : 0;
    var qMisc = !_.isNil(groupedRow.qMisc) ? groupedRow.qMisc : 0;
    var other = !_.isNil(groupedRow.airportTax) ? groupedRow.airportTax : 0;
    var variableTaxPercentage = !_.isNil(groupedRow.variableTaxPercentage) ? groupedRow.variableTaxPercentage : 0;
    var variableTaxComponent = getVariableTaxComponentFromSimpleHepWithDefaulting();
    var variableTaxComponentUsedChar = variableTaxComponent.split('');
    baseFare *= _.toNumber(variableTaxComponentUsedChar[0]);
    yq *= _.toNumber(variableTaxComponentUsedChar[1]);
    yr *= _.toNumber(variableTaxComponentUsedChar[2]);
    other *= _.toNumber(variableTaxComponentUsedChar[3]);
    q *= _.toNumber(variableTaxComponentUsedChar[4]);
    qMisc *= _.toNumber(variableTaxComponentUsedChar[5]);
    return variableTaxPercentage / 100 * (baseFare + yq + yr + other + q + qMisc);
  }
  function getVariableTaxComponentFromSimpleHepWithDefaulting() {
    var VARIABLE_TAX_COMPONENT_PATTERN = /^[0|1]{6}$|^$/;
    var variableTaxComponent = app.foSimpleHep.FO_VARIABLE_TAX_COMPONENT_USED;
    if (_.isNil(variableTaxComponent) || !variableTaxComponent.match(VARIABLE_TAX_COMPONENT_PATTERN)) {
      variableTaxComponent = '111000';
    }
    return variableTaxComponent;
  }
  return {
    updateEffectiveFaresInGroupedRows: updateEffectiveFaresInGroupedRows,
    updateRecommendedFaresInGroupedRows: updateRecommendedFaresInGroupedRows,
    updateCurrentFaresInGroupedRows: updateCurrentFaresInGroupedRows,
    alignEffectiveFares: alignEffectiveFares,
    setAdjustEffectiveFareData: setAdjustEffectiveFareData,
    checkAlignButtonStatus: checkAlignButtonStatus,
    getTotalFareThreshold: getTotalFareThreshold
  };
};
FaresOptimizerAlignFaresService.$inject = ['FaresOptimizerConstants', 'Restangular', 'FaresOptimizerDataTransformerService', '$q', 'App'];
module.exports = FaresOptimizerAlignFaresService;